import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  ButtonProps,
  HStack
} from '@chakra-ui/react';
import { PrimaryButton } from '@jurnee/common/src/components/primitives/buttons/PrimaryButton';
import { SecondaryButton } from '@jurnee/common/src/components/primitives/buttons/SecondaryButton';
import { cloneElement, HTMLAttributes, ReactElement, ReactNode, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  buttonLabel: string;
  children: ReactElement<HTMLAttributes<HTMLElement>>;
  message: string | ReactNode;
  title: string;
  buttonColor?: ButtonProps['colorScheme'];
  onConfirm(): void;
}

export function ConfirmModal(props: Props) {
  const { t } = useTranslation('common');

  const [isOpen, setIsOpen] = useState(false);
  const leastDestructiveRef = useRef<HTMLButtonElement>(null);

  function onOpen() {
    setIsOpen(true);
  }

  function onClose() {
    setIsOpen(false);
  }

  function onConfirm() {
    props.onConfirm();

    setIsOpen(false);
  }

  return (
    <>
      { cloneElement(props.children, { onClick: onOpen }) }

      <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} size="xl">
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader>
            { props.title }
            <AlertDialogCloseButton />
          </AlertDialogHeader>

          <AlertDialogBody>
            { props.message }
          </AlertDialogBody>

          <AlertDialogFooter>
            <HStack spacing={4} justifyContent="space-between" w="100%">
              <SecondaryButton colorScheme="gray" size="xs" onClick={onClose}>
                { t('common:buttons.close') }
              </SecondaryButton>

              <PrimaryButton colorScheme={props.buttonColor || 'pink'} size="xs" onClick={onConfirm}>
                { props.buttonLabel }
              </PrimaryButton>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}